import {LOG_OUT} from "../login/action";
import {
  SHOW_BUY_PERMITS_EXIT_ORDER_MODAL,
  HIDE_BUY_PERMITS_EXIT_ORDER_MODAL,
  SHOW_CHECKOUT_SELECT_ADDRESS_MODAL,
  HIDE_CHECKOUT_SELECT_ADDRESS_MODAL,
  GET_CHECKOUT_SELECT_ADDRESS_STATES,
  SET_CHECKOUT_SELECT_ADDRESS_STATES,
  GET_CHECKOUT_SELECTED_ADDRESS,
  SET_CHECKOUT_SELECTED_ADDRESS,
  SHOW_CHECKOUT_SELECT_PHONE_MODAL,
  HIDE_CHECKOUT_SELECT_PHONE_MODAL,
  GET_CHECKOUT_SELECT_PHONE_STATES,
  SET_CHECKOUT_SELECT_PHONE_STATES,
  GET_CHECKOUT_SELECTED_PHONE,
  SET_CHECKOUT_SELECTED_PHONE,
  SHOW_CHECKOUT_SELECT_EMAIL_MODAL,
  HIDE_CHECKOUT_SELECT_EMAIL_MODAL,
  GET_CHECKOUT_SELECT_EMAIL_STATES,
  SET_CHECKOUT_SELECT_EMAIL_STATES,
  GET_CHECKOUT_SELECTED_EMAIL,
  SET_CHECKOUT_SELECTED_EMAIL,
  GET_CHECKOUT_SELECTED_BILLING_ADDRESS,
  SET_CHECKOUT_SELECTED_BILLING_ADDRESS,
  SHOW_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL,
  HIDE_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL,
  GET_BUY_PERMIT_SELECTED_PERMIT,
  SET_BUY_PERMIT_SELECTED_PERMIT,
  GET_BUY_PERMIT_EDIT_VEHICLE,
  SET_BUY_PERMIT_EDIT_VEHICLE,
  SET_BUY_PERMIT_DRAFT_ORDER,
  RESET_BUY_PERMIT_DRAFT_ORDER,
  RESET_BUY_PERMIT_SELECTED_PERMIT,
  GET_BUY_PERMIT_ORDER_PAYMENT,
  SET_BUY_PERMIT_ORDER_PAYMENT,
  GET_BUY_PERMIT_PAYMENT_ORDER_DETAILS,
  UPDATE_BUY_PERMIT_VEHICLE_LIST,
  SHOW_BUY_PERMIT_THANK_YOU_MODAL,
  HIDE_BUY_PERMIT_THANK_YOU_MODAL,
  EMPTY_BUY_PERMIT_CART,
  GET_BUY_PERMIT_PAYMENT_METHODS,
  SET_BUY_PERMIT_PAYMENT_METHODS,
  SET_BUY_PERMIT_ACCEPTED_PAYMENT_METHODS,
  SET_BUY_PERMIT_PERMIT_NUMBER,
  SET_BUY_PERMIT_OTHER_PAYMENT,
  SHOW_BUY_PERMIT_UPDATE_VEHICLE_MODAL,
  HIDE_BUY_PERMIT_UPDATE_VEHICLE_MODAL,
  SET_SELECTED_DEFAULT_VEHICLE_LIST,
  HIDE_ALLOWED_VEHICLE_MODAL,
  SHOW_ALLOWED_VEHICLE_MODAL,
  GET_COUNTER,
  SET_COUNTER,
  EDIT_BUY_PERMIT_SELECTED_PERMIT,
  GET_BUY_CREDIT_CARD_VERIFICATION,
  SET_BUY_CREDIT_CARD_VERIFICATION,
  SET_TAX_RATE_VERIFICATION,
} from "./action";

export const defaultState = {
  buyPermitsExitOrderModal: false,
  checkoutSelectAddressModal: false,
  checkoutSelectBillingAddressModal: false,
  checkoutSelectAddressState: [],
  checkoutSelectedAddress: [],
  checkoutSelectPhoneModal: false,
  checkoutSelectPhoneState: [],
  checkoutSelectedPhone: [],
  checkoutSelectEmailModal: false,
  checkoutSelectEmailState: [],
  checkoutSelectedEmail: [],
  checkoutSelectedBillingAddress: [],
  buyPermitSelectedPermits: [],
  buyPermitDraftOrder: null,
  buyPemitEditVehicle: [],
  buyPemitOrderPayment: [],
  buyPermitRegisteredVehicleList: [],
  buyPermitThankYouModalState: false,
  buyPermitPaymentMethods: [],
  buyPermitAcceptedPaymentMethods: [],
  buyPermitUpdateVehicleModalState: false,
  buyPermitAllowedVehicleAlertState: false,
  allowedNumberOfVehcile: 0,
  setSelectedDefaultVehicleList: [],
  counterState: 0,
  buyPermitGetPermitNumber: {}
};

function exitOrderReducer(state = defaultState, action) {
  switch (action.type) {
    case SHOW_BUY_PERMITS_EXIT_ORDER_MODAL:
      return {
        ...state,
        buyPermitsExitOrderModal: true,
      };

    case HIDE_BUY_PERMITS_EXIT_ORDER_MODAL:
      return {
        ...state,
        buyPermitsExitOrderModal: false,
      };
    case SHOW_CHECKOUT_SELECT_ADDRESS_MODAL:
      return {
        ...state,
        checkoutSelectAddressModal: true,
      };
    case HIDE_CHECKOUT_SELECT_ADDRESS_MODAL:
      return {
        ...state,
        checkoutSelectAddressModal: false,
      };
    case SHOW_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL:
      return {
        ...state,
        checkoutSelectBillingAddressModal: true,
      };
    case HIDE_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL:
      return {
        ...state,
        checkoutSelectBillingAddressModal: false,
      };
    case GET_CHECKOUT_SELECT_ADDRESS_STATES:
      return {
        ...state,
        checkoutSelectAddressState: action.payload,
      };
    case SET_CHECKOUT_SELECT_ADDRESS_STATES:
      return {
        ...state,
        checkoutSelectAddressState: action.payload,
      };
    case GET_CHECKOUT_SELECTED_ADDRESS:
      return {
        ...state,
      };
    case SET_CHECKOUT_SELECTED_ADDRESS:
      return {
        ...state,
        checkoutSelectedAddress: action.payload,
      };

    case SHOW_CHECKOUT_SELECT_PHONE_MODAL:
      return {
        ...state,
        checkoutSelectPhoneModal: true,
      };
    case HIDE_CHECKOUT_SELECT_PHONE_MODAL:
      return {
        ...state,
        checkoutSelectPhoneModal: false,
      };
    case GET_CHECKOUT_SELECT_PHONE_STATES:
      return {
        ...state,
        checkoutSelectPhoneState: action.payload,
      };
    case SET_CHECKOUT_SELECT_PHONE_STATES:
      return {
        ...state,
        checkoutSelectPhoneState: action.payload,
      };
    case GET_CHECKOUT_SELECTED_PHONE:
      return {
        ...state,
      };
    case SET_CHECKOUT_SELECTED_PHONE:
      return {
        ...state,
        checkoutSelectedPhone: action.payload,
      };

    case SHOW_CHECKOUT_SELECT_EMAIL_MODAL:
      return {
        ...state,
        checkoutSelectEmailModal: true,
      };
    case HIDE_CHECKOUT_SELECT_EMAIL_MODAL:
      return {
        ...state,
        checkoutSelectEmailModal: false,
      };
    case GET_CHECKOUT_SELECT_EMAIL_STATES:
      return {
        ...state,
        checkoutSelectEmailState: action.payload,
      };
    case SET_CHECKOUT_SELECT_EMAIL_STATES:
      return {
        ...state,
        checkoutSelectEmailState: action.payload,
      };
    case GET_CHECKOUT_SELECTED_EMAIL:
      return {
        ...state,
      };
    case SET_CHECKOUT_SELECTED_EMAIL:
      return {
        ...state,
        checkoutSelectedEmail: action.payload,
      };
    case GET_CHECKOUT_SELECTED_BILLING_ADDRESS:
      return {
        ...state,
      };
    case SET_CHECKOUT_SELECTED_BILLING_ADDRESS:
      return {
        ...state,
        checkoutSelectedBillingAddress: action.payload,
      };
    case GET_BUY_PERMIT_SELECTED_PERMIT:
      return {
        ...state,
      };
    case SET_BUY_PERMIT_SELECTED_PERMIT:
      // let tmpIndex = state.buyPermitSelectedPermits.findIndex((e) => e?.permit?.id === action.payload.permit.id);
      let updatecheck = false;
      let filteredData = state.buyPermitSelectedPermits.map((ele) => {
        return ele;
        // if (ele.permit?.id === action.payload.permit?.id) {
        //   updatecheck = true;
        //   return {
        //     ...action.payload,
        //   };
        // } else {
        //   return ele;
        // }
      });

      return {
        ...state,
        buyPermitSelectedPermits: updatecheck
          ? filteredData
          : [...filteredData, action.payload],
      };
    case EDIT_BUY_PERMIT_SELECTED_PERMIT:
      let filterData = state.buyPermitSelectedPermits.map((ele) => {
        if (ele.permit.id === action.payload.editPermitId.permit_id) {
          return {
            ...action.payload,
          };
        } else {
          return ele;
        }
      });
      return {...state, buyPermitSelectedPermits: filterData};
    // return{
    //     ...state,
    //     buyPermitSelectedPermits:action.payload.editPermitId.permit_id?filterData:[...filterData,action.payload]
    // }
    case RESET_BUY_PERMIT_SELECTED_PERMIT:
      return {
        ...state,
        buyPermitSelectedPermits: action.payload,
      };
    case GET_BUY_PERMIT_EDIT_VEHICLE:
      return {
        ...state,
      };
    case SET_BUY_PERMIT_EDIT_VEHICLE:
      return {
        ...state,
        buyPemitEditVehicle: action.payload,
      };
    case SET_BUY_PERMIT_DRAFT_ORDER:
      return {
        ...state,
        buyPermitDraftOrder: action.payload,
      };
    case RESET_BUY_PERMIT_DRAFT_ORDER:
      return {
        ...state,
        buyPermitDraftOrder: null,
      };
    case GET_BUY_PERMIT_PAYMENT_ORDER_DETAILS:
      return {
        ...state.buyPemitOrderPayment,
      };
    case SET_BUY_PERMIT_ORDER_PAYMENT:
      return {
        ...state,
        buyPemitOrderPayment: action.payload,
      };
    case UPDATE_BUY_PERMIT_VEHICLE_LIST:
      return {
        ...state,
        buyPermitRegisteredVehicleList: action.payload,
      };
    case SHOW_BUY_PERMIT_THANK_YOU_MODAL:
      return {
        ...state,
        buyPermitThankYouModalState: true,
      };
    case HIDE_BUY_PERMIT_THANK_YOU_MODAL:
      return {
        ...state,
        buyPermitThankYouModalState: false,
      };
    case EMPTY_BUY_PERMIT_CART:
      return {
        ...state,
        buyPermitSelectedPermits: [],
        buyPermitDraftOrder: null,
      };
    // case GET_BUY_PERMIT_PAYMENT_METHODS:
    //     return{
    //         ...state.buyPermitPaymentMethods,
    //     }
    case SET_BUY_PERMIT_PAYMENT_METHODS:
      return {
        ...state,
        buyPermitPaymentMethods: action.payload,
      };
    case SET_BUY_PERMIT_ACCEPTED_PAYMENT_METHODS:
      return {
        ...state,
        buyPermitAcceptedPaymentMethods: action.payload,
      };
    case SET_BUY_PERMIT_PERMIT_NUMBER:
      return {
        ...state,
        buyPermitGetPermitNumber: action.payload,
      };
    case SHOW_BUY_PERMIT_UPDATE_VEHICLE_MODAL:
      return {
        ...state,
        buyPermitUpdateVehicleModalState: true,
      };
    case HIDE_BUY_PERMIT_UPDATE_VEHICLE_MODAL:
      return {
        ...state,
        buyPermitUpdateVehicleModalState: false,
      };
    case SET_SELECTED_DEFAULT_VEHICLE_LIST:
      return {
        ...state,
        setSelectedDefaultVehicleList: [
          ...state.setSelectedDefaultVehicleList,
          action.payload,
        ],
      };
    case SHOW_ALLOWED_VEHICLE_MODAL:
      return {
        ...state,
        buyPermitAllowedVehicleAlertState: true,
        allowedNumberOfVehcile: action.payload,
      };
    case HIDE_ALLOWED_VEHICLE_MODAL:
      return {
        ...state,
        buyPermitAllowedVehicleAlertState: false,
        allowedNumberOfVehcile: 0,
      };
    case SET_BUY_CREDIT_CARD_VERIFICATION:
      return {
        ...state,
        buyPemitCheckCreditCradDetails: action.payload,
      };
    case SET_TAX_RATE_VERIFICATION:
      return {
        ...state,
        buyPermitTaxRatePrice: action.payload,
      };
    case GET_COUNTER:
      return {
        ...state,
      };
    case SET_COUNTER:
      return {
        ...state,
        counterState: action.payload,
      };
    case LOG_OUT:
      return defaultState;
    default:
      return state;
  }
}

export default exitOrderReducer;
